import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/medical-weight-loss/insurance")({
  component: () => <Outlet />,
});
